export default __webpack_public_path__ + "1143c844a262ac323e566f2ab6872ede.webp";